import { createContext, ReactNode, useContext } from "react";

export type AlertType = "success" | "warning" | "error" | "info";

interface IOperationOptions {
    showProgress?: boolean;
}

export interface IAction {
    label: string;
    action?: () => Promise<void>
}

export interface IOperationContext {

    begin(options?: IOperationOptions): void;

    end(): void;

    showAlert(body: ReactNode, type: AlertType, duration?: number) : void;

    showErrorAsync<T extends { [key: string]: IAction }>(body: ReactNode, actions?: T): Promise<keyof T>;

    showMessageAsync<T extends { [key: string]: IAction }>(body: ReactNode, title: string, actions?: T): Promise<keyof T>;

    confirmAsync(body: ReactNode): Promise<boolean>;
}

export const OperationContext = createContext({} as IOperationContext);


export function useOperation() {
    return useContext(OperationContext);
}